import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const HospitalTransport = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <TextField
        label="Hospital Transport"
        helperText="Explain the plan for transporting patients to hospital"
        fullWidth
        multiline
        minRows={2}
        value={medPlan?.hospitalTransport}
        autoComplete="off"
        name="medplan-hospitaltransport"
        InputLabelProps={{
          shrink: !!medPlan?.hospitalTransport,
        }}
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            hospitalTransport: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(HospitalTransport)
